import {
  defaultStandardCode,
  defaultWithoutLinkCode,
  defaultWithoutBillableCode,
  defaultOnlyActionIconsCode,
  statusPageCode,
  landingPageCode
} from './headersCode';

import {
  defaultStandard,
  defaultWithoutLink,
  defaultWithoutBillable,
  defaultOnlyActionIcons,
  statusPage,
  landingPage
} from './headersLayouts';

const headersSet = [
  {
    type: 'standard',
    previews: [
      {
        component: defaultStandard,
        codeTemplate: defaultStandardCode,
        imagePath: 'standardDefault.png',
        modalPreviewClassName: 'with-padding',
        optionsGroup: [
          {
            label: 'Default',
            options: [
              { label: 'Default', type: 'radio', options: {} },
            ]
          }
        ],
      },
      {
        component: defaultWithoutLink,
        codeTemplate: defaultWithoutLinkCode,
        imagePath: 'standardWithoutLink.png',
        modalPreviewClassName: 'with-padding',
        optionsGroup: [
          {
            label: 'Without Link',
            options: [
              { label: 'Default', type: 'radio', options: {} },
            ]
          }
        ],
      },
      {
        component: defaultWithoutBillable,
        codeTemplate: defaultWithoutBillableCode,
        imagePath: 'standardWithoutBillable.png',
        modalPreviewClassName: 'with-padding',
        optionsGroup: [
          {
            label: 'Without Billable ID Menu',
            options: [
              { label: 'Default', type: 'radio', options: {} },
            ]
          }
        ],
      },
      {
        component: defaultOnlyActionIcons,
        codeTemplate: defaultOnlyActionIconsCode,
        imagePath: 'standardOnlyActionIcons.png',
        modalPreviewClassName: 'with-padding',
        optionsGroup: [
          {
            label: 'Only Action Icons',
            options: [
              { label: 'Default', type: 'radio', options: {} },
            ]
          }
        ],
      }
    ]
  },
  {
    type: 'status page',
    previews: [
      {
        component: statusPage,
        codeTemplate: statusPageCode,
        imagePath: 'statusPage.png',
        modalPreviewClassName: 'with-padding',
        optionsGroup: [
          {
            label: 'Default',
            options: [
              { label: 'Default', type: 'radio', options: {} },
            ]
          }
        ],
      }
    ]
  },
  {
    type: 'landing page',
    previews: [
      {
        component: landingPage,
        codeTemplate: landingPageCode,
        imagePath: 'landingPage.png',
        modalPreviewClassName: 'with-padding',
        optionsGroup: [
          {
            label: 'Two Levels',
            options: [
              { label: 'Default', type: 'radio', options: {} },
            ]
          }
        ],
      }
    ]
  }
];

export default headersSet;



// WEBPACK FOOTER //
// ./src/containers/components/Header/constants/headersSet.js